export default "__VITE_ASSET__D07d10_Q__"